/* unplugin-vue-components disabled */import { render } from "./paymentRecords.vue?vue&type=template&id=7bf87482&scoped=true"
import script from "./paymentRecords.vue?vue&type=script&lang=js"
export * from "./paymentRecords.vue?vue&type=script&lang=js"

import "./paymentRecords.vue?vue&type=style&index=0&id=7bf87482&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bf87482"]])

export default __exports__